<template>
    <div class="map">
        <div style="width:880px;height:660px" ref="chartsDOM"></div>
    </div>
</template>

<script>
import axios from 'axios'
import zhong from '../assets/json/zhong.js'
export default {
    mounted() {
        // 初始化统计图对象
        var myChart = this.$echarts.init(this.$refs["chartsDOM"]);
        // 显示 loading 动画
        myChart.showLoading();
        // \node_modules\echarts\lib\coord\geo\fix\nanhai.js 修改mapType可显示隐藏南海诸岛
        // 再得到数据的基础上，进行地图绘制
        myChart.hideLoading();
            // 注册地图(数据放在axios返回对象的data中哦)
            this.$echarts.registerMap('China', zhong);
            var option = {
                series: [
                    {
                        name: '中国地图',
                        type: 'map',
                        map: 'China',// 这个是上面注册时的名字哦，registerMap（'这个名字保持一致'）
                        zoom: 2,
                        left:'30%',
                        bottom:0,
                        top:'50%',
                        label: {
                            show: false,
                            fontSize: 10
                        },
                        itemStyle: {
                            normal: {
                                areaColor: '#fff',
                                borderColor: '#066FF2',
                                borderWidth: 1
                            },
                            emphasis: {
                                show: false,
                                areaColor: '#eee'
                            },
                        },
                    },

                ]
            };
            myChart.setOption(option);
        // axios.get('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json').then(res => {
        //     // 得到结果后，关闭动画
            
        // })
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>